// Import Swiper styles
import "swiper/swiper-bundle.css";

if (process.client) {
  // Import Swiper Element bundle - auto-registers custom elements
  require("swiper/swiper-element-bundle.js");

  // Import classic Swiper with ALL modules for backward compatibility
  const SwiperBundle = require("swiper/swiper-bundle.js");
  window.Swiper = SwiperBundle.default || SwiperBundle;

  // NOTE: swiper-bundle.js includes all modules pre-configured:
  // Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar,
  // Parallax, Zoom, Controller, A11y, History, HashNavigation,
  // Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade,
  // EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards
}
